import { atomWithCache } from "jotai-cache";
import { atomFamily } from "jotai/utils";

import { $accessTokenFunc } from "../authenication";
import { $docsApi } from "../docsapi/docsapi.atom";
import type { SearchUserResult } from "../docsapi/docsapi.types";

export const $userById = atomFamily((userId: string) => {
	const userAtom = atomWithCache(async (get): Promise<SearchUserResult | null> => {
		if (!userId) {
			return null;
		}

		const docsApi = get($docsApi);
		const token = await get($accessTokenFunc).getAccessTokenSilently?.();
		return docsApi.users.get(userId, token);
	});
	userAtom.debugLabel = `userById::${userId}`;
	return userAtom;
});
